/* tslint:disable */
/* eslint-disable */
/**
 * back-office-service
 * Back Office Service
 *
 * The version of the OpenAPI document: 0.29.35
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { VendorOutcomeCategory } from './VendorOutcomeCategory';
import {
    VendorOutcomeCategoryFromJSON,
    VendorOutcomeCategoryFromJSONTyped,
    VendorOutcomeCategoryToJSON,
} from './VendorOutcomeCategory';

/**
 * 
 * @export
 * @interface VendorOutcome
 */
export interface VendorOutcome {
    /**
     * false = an adverse/attention signal for its category (sanctions/watchlist/PEP/adverse-media match,
     * a reject/refer decision, or a no-match source). true = a clearing/positive signal.
     * @type {boolean}
     * @memberof VendorOutcome
     */
    cleared: boolean;
    /**
     * The vendor's exact outcome wording, preserved verbatim.
     * @type {string}
     * @memberof VendorOutcome
     */
    rawOutcome: string;
    /**
     * 
     * @type {VendorOutcomeCategory}
     * @memberof VendorOutcome
     */
    category: VendorOutcomeCategory;
}



/**
 * Check if a given object implements the VendorOutcome interface.
 */
export function instanceOfVendorOutcome(value: object): value is VendorOutcome {
    if (!('cleared' in value) || value['cleared'] === undefined) return false;
    if (!('rawOutcome' in value) || value['rawOutcome'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function VendorOutcomeFromJSON(json: any): VendorOutcome {
    return VendorOutcomeFromJSONTyped(json, false);
}

export function VendorOutcomeFromJSONTyped(json: any, ignoreDiscriminator: boolean): VendorOutcome {
    if (json == null) {
        return json;
    }
    return {
        
        'cleared': json['cleared'],
        'rawOutcome': json['rawOutcome'],
        'category': VendorOutcomeCategoryFromJSON(json['category']),
    };
}

export function VendorOutcomeToJSON(value?: VendorOutcome | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'cleared': value['cleared'],
        'rawOutcome': value['rawOutcome'],
        'category': VendorOutcomeCategoryToJSON(value['category']),
    };
}

